import R from 'ramda'

const RECURRING_CONSENT_TRIGGER_TYPE = 'OPT_IN_RECURRING'
const RECURRING_CONSENT_DISPLAY_TYPE = 'Received Recurring Consent'

const isRecurringConsentFormTrigger = R.propEq(
  'type',
  RECURRING_CONSENT_DISPLAY_TYPE
)

const convertRecurringConsentFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(RECURRING_CONSENT_TRIGGER_TYPE),
  data: R.always('notification_messages'),
  operator: R.always('AND'),
  primary: R.T
})

export {
  isRecurringConsentFormTrigger,
  convertRecurringConsentFormTriggerToWidgetTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/form-to-widget/received-recurring-consent.js